import { CSSProperties } from "react";
import { createTheme } from "@mui/material/styles";
import { PaletteColorOptions } from "@mui/material";
import { themeComponents } from "./themeComponents";
import { paletteDataDarkMode, paletteDataLightMode } from "./themePalette";
import { themeTypography } from "./themeTypography";
// import { isLightMode } from "utils/GenericFunctions";

// @mui/material/styles.js

/**
 * @typedef {import("@mui/material/styles").PaletteColorOptions} PaletteColorOptions
 * @typedef {import("@mui/material/styles").CSSProperties} CSSProperties
 */

/**
 * @typedef {Object} CustomPalette
 * @property {PaletteColorOptions} white
 * @property {PaletteColorOptions} formlink
 * @property {PaletteColorOptions} black
 * @property {PaletteColorOptions} lightgrey
 */

/**
 * @typedef {Object} TypographyVariants
 * @property {CSSProperties} body3
 * @property {CSSProperties} bottomheadernav
 * @property {CSSProperties} closebutton
 * @property {CSSProperties} formlink
 * @property {CSSProperties} [listitem]
 */

/**
 * @typedef {Object} TypographyVariantsOptions
 * @property {CSSProperties} [body3]
 * @property {CSSProperties} [bottomheadernav]
 * @property {CSSProperties} [closebutton]
 * @property {CSSProperties} [formlink]
 * @property {CSSProperties} [listitem]
 */

/**
 * @module "@mui/material/styles"
 */

// @mui/material/Button.js
/**
 * @typedef {Object} ButtonPropsSizeOverrides
 * @property {true} xlarge
 * @property {true} xxlarge
 */
/**
 * @typedef {Object} ButtonPropsColorOverrides
 * @property {true} white
 * @property {true} black
 * @property {true} lightgrey
 */

/**
 * @module "@mui/material/Button"
 */

// @mui/material/Chip.js

/**
 * @typedef {Object} ChipPropsColorOverrides
 * @property {true} purplelight
 * @property {true} greyselected
 * @property {true} infolight
 * @property {true} successlight
 * @property {true} errorlight
 * @property {true} warninglight
 * @property {true} formlink
 */

/**
 * @typedef {Object} ChipPropsSizeOverrides
 * @property {true} singleLetter
 * @property {true} xsmall
 * @property {true} xsmallicon
 */

/**
 * @module "@mui/material/Chip"
 */


// Update the Typography's variant prop options
// @mui/material/Typography.js

/**
 * @typedef {Object} TypographyPropsVariantOverrides
 * @property {true} body3
 * @property {false} h3
 * @property {true} bottomheadernav
 * @property {true} closebutton
 * @property {true} formlink
 * @property {true} listitem
 */

/**
 * @module "@mui/material/Typography"
 */


const getTheme = (mode = "dark") => {
  const isLight = false;

  return createTheme({
    palette: isLight ? paletteDataLightMode : paletteDataDarkMode,
    // breakpoints: themeBreakpoints,
    typography: themeTypography,
    components: themeComponents(isLight),
  });
};

export { getTheme };